import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { setVisitorBookingChipColor } from './visitorBooking';

const PREFIX = 'IssueReportStatusIndicator';

const classes = {
    root: `${PREFIX}-root`,
    normal: `${PREFIX}-normal`,
    unavailable: `${PREFIX}-unavailable`,
    unknown: `${PREFIX}-unknown`,
    chip: `${PREFIX}-chip`,
};

const StyledChip = styled(Chip)((
    {
        theme,
    },
) => ({
    [`& .${classes.chip}`]: {
        width: 10,
        height: 10,
        borderRadius: 5,
        float: 'right',
    },

    [`& .${classes.normal}`]: {
        backgroundColor: theme.palette.success.main,
    },

    [`& .${classes.unavailable}`]: {
        backgroundColor: theme.palette.error.main,
    },

    [`& .${classes.unknown}`]: {
        backgroundColor: 'lightgray',
    },
}));

interface VisitorBookingStatusChipProps {
    label: 'Started' | 'Not Started' | 'Finished';
}

const VisitorBookingStatusChip = (props: VisitorBookingStatusChipProps) => {

    const labelColor = setVisitorBookingChipColor(props.label);

    const { t } = useTranslation();

    const statuses = {
        Started: 'started',
        'Not Started': 'not_started',
        Finished: 'finished',
    };

    return (
        <StyledChip
            label={t(`common.${statuses[props.label]}`)}
            size={'medium'}
            sx={{ backgroundColor: labelColor, color: 'white', fontWeight: 'bold' }}
        />
    );
};

export default VisitorBookingStatusChip;
